import api from "@/services/api";

import {
  SET_TRACKS,
  SET_ALBUMS,
  LIKE_ALBUM,
  UNLIKE_ALBUM,
  DELETE_ALBUM
} from "@/store/mutation-types";

export default {
  async fetch({ commit }, { type, params }) {
    const { payload = {} } = await api.albums.fetch(type, params);
    const { albums = [], album = {} } = payload;
    const hasOneAlbum = ["album", "editing", "review"].includes(type);

    commit(SET_ALBUMS, hasOneAlbum ? [album] : albums);

    return payload;
  },
  async tracks({ commit }, { params }) {
    const { id } = params;
    const { payload = {} } = await api.albums.tracks(id);
    const { tracks = [] } = payload;

    commit(`tracks/${SET_TRACKS}`, tracks, { root: true });

    return payload;
  },
  async like({ commit, dispatch }, id) {
    try {
      commit(LIKE_ALBUM, id);

      await api.albums.like(id);

      return true;
    } catch (error) {
      commit(UNLIKE_ALBUM, id);

      if (this.$app.$errorHandler.unauthorizedRequest(error)) {
        dispatch("modal/open", { name: "login" }, { root: true });
      } else {
        this.$app.$errorHandler.add(error);
      }

      return false;
    }
  },
  async unlike({ commit, dispatch }, id) {
    try {
      commit(UNLIKE_ALBUM, id);

      await api.albums.like(id);

      return true;
    } catch (error) {
      commit(LIKE_ALBUM, id);

      if (this.$app.$errorHandler.unauthorizedRequest(error)) {
        dispatch("modal/open", { name: "login" }, { root: true });
      } else {
        this.$app.$errorHandler.add(error);
      }

      return false;
    }
  },
  async delete({ commit, state, dispatch }, { id, type }) {
    const { confirm = false } = await dispatch(
      `modal/open`,
      {
        name: "confirm",
        data: {
          title: this.$app.$l10n("ALBUM_REMOVE"),
          caption: this.$app.$l10n("SELECTED_ALBUM_WILL_DELETED")
        }
      },
      { root: true }
    );

    if (confirm) {
      const album = state.albums[id];
      const tracksIds = album.tracks;

      await api.albums.delete({ albumId: id });

      if (type === "full") {
        await this.$app.$router.push("/profile").catch(() => {});
      }

      if (album.tracks.length) {
        await dispatch(`tracks/delete`, { ids: tracksIds }, { root: true });
      }

      commit(DELETE_ALBUM, id);
    }

    return { id, deleted: confirm };
  },
  async create({ commit }, params) {
    const { title } = params;

    if (title && typeof title === "string") {
      const { payload = {} } = await api.albums.create(params);
      const { album = {} } = payload;

      commit(SET_ALBUMS, [album]);

      return album;
    }

    return false;
  },
  async update({ commit }, params) {
    const { payload = {} } = await api.albums.update(params);
    const { album = {} } = payload;

    commit(SET_ALBUMS, [album]);

    return album;
  },
  async updateCover({ commit }, params) {
    const { payload = {} } = await api.albums.cover(params);
    const { album = {} } = payload;

    commit(SET_ALBUMS, [album]);

    return album;
  },
  async updateGenres({ commit }, params) {
    const { payload = {} } = await api.albums.genres(params);
    const { album = {} } = payload;

    commit(SET_ALBUMS, [album]);

    return album;
  },
  async sortTracks({ commit }, params) {
    const { payload = {} } = await api.albums.sortTracks(params);
    const { album = {} } = payload;

    commit(SET_ALBUMS, [album]);

    return album;
  },
  async uploadTrack({ commit }, params) {
    const { payload = {} } = await api.albums.uploadTrack(params);
    const { track = {} } = payload;

    commit(`tracks/${SET_TRACKS}`, [track], { root: true });

    return track;
  },
  async save({ commit, rootGetters }, { form, preventBack }) {
    try {
      const { payload = {} } = await api.albums.save(form);
      const { album, tracks = [] } = payload;

      commit(SET_ALBUMS, [album]);
      commit(`tracks/${SET_TRACKS}`, tracks, { root: true });

      const currentPlaylistId = rootGetters["player/playlistId"];

      if (currentPlaylistId && currentPlaylistId === album.id) {
        this.$app.$player.stop();
        this.$app.$player.clearQueue();
      }

      if (!preventBack) {
        await this.$app.$router.push(
          `/albums/${album.id}${album.active ? "" : "/review"}`
        );
      }

      return album;
    } catch (error) {
      console.error(error);
    }
  }
};
